import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindowClose,
} from '@fortawesome/free-solid-svg-icons';

import { Container, ErrorText, CloseButton } from './styles';

const ErrorMessage = ({error, setError}) => (
  <Container>
    <ErrorText>{error}</ErrorText>
    <CloseButton onClick={() => setError(null)}>
      <FontAwesomeIcon
        size="2x"
        color={'white'}
        icon={faWindowClose}
      />
    </CloseButton>
  </Container>
);

export default ErrorMessage;
